import { createFileRoute } from "@tanstack/react-router"

import { PoliciesRouteComponent } from "@/routes/policies"

export const Route = createFileRoute("/qr/$qrLookupID/policies")({
  staticData: {
    pageName: "Policies",
  },
  component: PoliciesRouteComponent,
})
